import { IDemoFlow, performed, proposal, step } from './types';
import { DEMO_UAT_RECORDS } from './uatRecords';

const { editCampaign } = DEMO_UAT_RECORDS;

// Figma E1 `6567:2311`: Edit Campaign with Edit in builder and Update. The current -> new row is a
// client shape: the field-change payload is still an open question for the backend.

export const EDIT_CAMPAIGN_FLOWS: IDemoFlow[] = [
  {
    id: 'edit-campaign',
    prompt: 'Change the end date of campaign #1 to 15 Jan 2027',
    reply: now => ({
      outcome: 'action_proposed',
      answer: `I will change the end date of ${editCampaign.name} (Campaign ID: ${editCampaign.id}). Shall I proceed?`,
      action: proposal(
        step(
          'update_campaign',
          'Edit Campaign',
          {
            entity: 'campaign',
            id: editCampaign.id,
            name: editCampaign.name,
            state: 'active',
            subtype: 'stamp'
          },
          { end_date: { current: '31 Dec 2026', next: '15 Jan 2027' } }
        ),
        now,
        {
          buttons: [
            { id: 'open_builder', label: 'Edit in builder' },
            { id: 'confirm', label: 'Update' }
          ],
          builder: { form: 'campaign_edit', prefill: { end_date: '2027-01-15' }, step: 'info' }
        }
      )
    }),
    confirm: action => ({
      outcome: 'action_performed',
      answer: `Updated the end date of ${editCampaign.name} (Campaign ID: ${editCampaign.id}) to 15 Jan 2027.`,
      action: performed(action, { id: editCampaign.id, state: 'active' })
    })
  }
];
